import styled from '@emotion/styled';
import { Button as MuiButton } from '@mui/material';
import { theme } from '../../constants/theme';

/**
 * Styled CustomButton Component using Emotion
 * Provides base styling that works with MUI Button
 */
export const StyledCustomButton = styled(MuiButton)`
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.medium};
  text-transform: none;
  border-radius: ${theme.borderRadius.sm};
  transition: all ${theme.transitions.duration.normal} ${theme.transitions.timing.easeInOut};
  box-shadow: none;

  &:hover {
    box-shadow: ${theme.shadows.md};
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  /* Variant: Primary */
  &.variant-primary {
    background-color: ${theme.colors.primary.main};
    color: ${theme.colors.primary.contrastText};

    &:hover {
      background-color: ${theme.colors.primary.dark};
    }

    &:focus {
      box-shadow: ${theme.shadows.primary};
    }
  }

  /* Variant: Secondary */
  &.variant-secondary {
    background-color: ${theme.colors.secondary.main};
    color: ${theme.colors.secondary.contrastText};

    &:hover {
      background-color: ${theme.colors.secondary.dark};
    }

    &:focus {
      box-shadow: ${theme.shadows.secondary};
    }
  }

  /* Variant: Outline */
  &.variant-outline {
    background-color: transparent;
    border: 1px solid ${theme.colors.primary.main};
    color: ${theme.colors.primary.main};

    &:hover {
      background-color: ${theme.colors.primary.main}10;
    }
  }

  /* Variant: Text */
  &.variant-text {
    background-color: transparent;
    color: ${theme.colors.primary.main};

    &:hover {
      background-color: ${theme.colors.primary.main}10;
    }
  }

  /* Variant: Danger */
  &.variant-danger {
    background-color: ${theme.colors.error.main};
    color: ${theme.colors.error.contrastText};

    &:hover {
      background-color: ${theme.colors.error.dark};
    }

    &:focus {
      box-shadow: ${theme.shadows.error};
    }
  }

  /* Variant: Success */
  &.variant-success {
    background-color: ${theme.colors.success.main};
    color: ${theme.colors.success.contrastText};

    &:hover {
      background-color: ${theme.colors.success.dark};
    }

    &:focus {
      box-shadow: ${theme.shadows.success};
    }
  }

  /* Size: Small */
  &.size-sm {
    height: ${theme.components.button.height.sm};
    padding: ${theme.components.button.padding.sm};
    font-size: ${theme.typography.fontSize.sm};
  }

  /* Size: Medium (default) */
  &.size-md {
    height: ${theme.components.button.height.md};
    padding: ${theme.components.button.padding.md};
    font-size: ${theme.typography.fontSize.base};
  }

  /* Size: Large */
  &.size-lg {
    height: ${theme.components.button.height.lg};
    padding: ${theme.components.button.padding.lg};
    font-size: ${theme.typography.fontSize.md};
  }

  /* Full Width */
  &.fullWidth {
    width: 100%;
  }

  /* Loading State */
  &.loading {
    position: relative;
    color: transparent;

    .spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
